import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLGLIncidentDetailsPage } from 'gwce-capability-fnol-gl-react-ext';
import { FNOLCPIncidentDetailsPage } from 'gwce-capability-fnol-cp-react-ext';
import { FNOLIMIncidentDetailsPage } from 'wnice-capability-fnol-im-react';
import { FNOLCRIncidentDetailsPage } from 'wnice-capability-fnol-cr-react';
import { ProductUtil } from 'wnice-portals-util-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';

function FNOLCPPIncidentDetailsPage(props) {
    const {
        wizardData: claimVM
    } = props;

    const lineSelected = _.get(claimVM.value, 'policy.lobCode_Ext');

    switch(lineSelected) {
        case ProductUtil.FNOL_LOB_GL:
            return <FNOLGLIncidentDetailsPage {...props} />;
        case ProductUtil.FNOL_LOB_CP:
            return <FNOLCPIncidentDetailsPage {...props} />;
        case ProductUtil.FNOL_LOB_IM:
            return <FNOLIMIncidentDetailsPage {...props} />;
        case ProductUtil.FNOL_LOB_CR:
            return <FNOLCRIncidentDetailsPage {...props} />;
        default:
            return null; 
    }
    
}

FNOLCPPIncidentDetailsPage.propTypes = wizardProps;
FNOLCPPIncidentDetailsPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
};
export default withRouter(withAuthenticationContext(FNOLCPPIncidentDetailsPage));
